import { LOCALE_ID, NgModule, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { appRoutes } from './app.routes';
import { pt_BR, NZ_I18N } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import en from '@angular/common/locales/en';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import {
  RouterModule,
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { environment } from '@/environments/environment';
import { LockScreenLoaderComponent } from './common/components/lock-screen-loader/lock-screen-loader.component';
import { AuthInterceptor } from './features/auth/interceptors/auth-interceptor';
import { CancelRequestsInterceptor } from './common/interceptors/cancel-requests';

import localePt from '@angular/common/locales/pt';
import { UnauthorizedInterceptor } from './common/interceptors/unauthorized.interceptor';

registerLocaleData(localePt);

registerLocaleData(en);

registerLocaleData(localePt, 'pt');

@NgModule({
  declarations: [AppComponent],
  imports: [
    LockScreenLoaderComponent,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    ...environment.imports,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: LOCALE_ID,
      useValue: 'pt',
    },

    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL',
    },

    { provide: NZ_I18N, useValue: pt_BR },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CancelRequestsInterceptor,
      multi: true,
    },
    ...environment.providers,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
